export enum IncomeCalculationCycle {
    None = 0,
    PerPayCheck = 1,
    Monthly = 2
}
